export default __webpack_public_path__ + "static/media/dashboard.26f7d399.png";